export default "__VITE_ASSET__0cd67846__"